import { Pipe, PipeTransform } from '@angular/core';
import { cloneDeep } from 'lodash';

@Pipe({
  name: 'deepClone',
})
export class DeepClonePipe implements PipeTransform {
  transform<T>(value: T): T {
    return cloneDeep(value);
  }
}
